// extracted by mini-css-extract-plugin
module.exports = {"notificationsContainer":"styles_notificationsContainer__1I_5m","openedNotificationsContainer":"styles_openedNotificationsContainer__2jnk7","shadow":"styles_shadow__2xx3I"};